import React, { useId } from "react";
import PropTypes from "prop-types";
import Button from "../atoms/Button";
import "./ConfirmDialog.scss";

export default function ConfirmDialog({
    isOpen,
    title,
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    processingLabel,
    onConfirm,
    onCancel,
    isProcessing = false,
    error,
    confirmVariant = "danger",
}) {
    const titleId = useId();
    const messageId = `${titleId}-message`;

    if (!isOpen) {
        return null;
    }

    const confirmText = isProcessing ? (processingLabel || `${confirmLabel}…`) : confirmLabel;

    return (
        <div className="confirm-dialog">
            <div className="confirm-dialog__overlay" aria-hidden="true" />
            <div
                className="confirm-dialog__content"
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
                aria-describedby={messageId}
            >
                <header className="confirm-dialog__header">
                    <h2 id={titleId}>{title}</h2>
                </header>
                <p id={messageId} className="confirm-dialog__message">{message}</p>
                {error && (
                    <p className="confirm-dialog__error" role="alert">{error}</p>
                )}
                <div className="confirm-dialog__actions">
                    <Button
                        text={cancelLabel}
                        variant="secondary"
                        onClick={onCancel}
                        disabled={isProcessing}
                    />
                    <Button
                        text={confirmText}
                        variant={confirmVariant}
                        onClick={onConfirm}
                        disabled={isProcessing}
                    />
                </div>
            </div>
        </div>
    );
}

ConfirmDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.node.isRequired,
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    processingLabel: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isProcessing: PropTypes.bool,
    error: PropTypes.string,
    confirmVariant: PropTypes.oneOf(["primary", "secondary", "success", "danger", "warning", "info"]),
};
